var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _polygon2, _polygon3, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurismo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 696.9 211.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3c77bc;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#e63420;}.cls-3{fill:#010101;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m213.9,139h-27.4l-8.4,43.5h-22l8.4-43.5h-27.5l3.3-17.2h76.8l-3.2,17.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m301.5,121.8l-6.4,33c-2.9,14.9-8.3,21.8-18.1,25.8-6.7,2.7-15.8,4-25.9,4-22.1,0-38.5-6.8-34.3-28.9l6.5-33.9h21.9l-6.5,33.5c-1.8,9.2,4.3,12.3,14.8,12.3,4.4.1,8.7-.9,12.6-2.8,3.5-1.9,6.2-5.3,7.3-11.2l6.2-31.8h21.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m378.8,182.5h-24.4l-7.6-18.2h-23.1l-3.5,18.2h-21.9l11.7-60.7h53.9c13.6,0,21.7,5.7,21.7,15.9,0,6.8-1.7,12-5.6,15.9-3,3.1-7,5.1-11.2,5.8l-.2.8,10.2,22.3Zm-19.7-35.2c1.2-1.3,1.9-3.1,1.8-4.9,0-2.7-1.6-4.2-5.7-4.2h-26.5l-2.2,11.5h26.5c2.3.2,4.5-.7,6.1-2.4h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m384.2,182.5l11.7-60.7h21.9l-11.7,60.7h-21.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m441.2,162.4c.7,6.7,5.9,8.5,14.7,8.5,6.4,0,10.6-.9,13-2.5,1.4-.9,2.2-2.4,2.3-4.1,0-2.8-2.7-3.7-7-4.2l-22.8-2.5c-12.2-1.4-19.8-5.3-19.8-15.1-.1-5.9,2.6-11.6,7.3-15.3,7.1-5.6,18.9-7.4,35.5-7.4,21.7,0,35.5,4.2,35.5,17.5,0,1-.1,1.9-.2,2.9h-25.2c-.5-4.9-5.1-6.9-13.7-6.9-5.7,0-9.4.8-11.4,2.2-1.4.7-2.2,2.1-2.3,3.6,0,2.3,2.1,3.2,7.2,3.7l24,2.3c12.4,1.2,19.5,5.3,19.5,14.9,0,7.1-3,14.3-8.9,18.2-7.3,4.9-19,6.4-36.6,6.4-23.1,0-36.5-3.9-36.5-18.3,0-1.3.1-2.6.3-3.9h25.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m595.5,182.5h-21.9l7.9-41.3h-.5l-25.1,41.3h-16.6l-9.6-41.8h-.6l-8,41.8h-20.8l11.7-60.7h32.8l7,34h.6l19.6-34h35.3l-11.8,60.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m647,184.6c-25.6,0-39.1-8.3-39.1-25.8-.1-9.9,3.7-19.5,10.6-26.7,8.4-8.4,21.5-12.4,39.3-12.4,25.6,0,39.1,8.3,39.1,25.8.1,9.9-3.7,19.5-10.6,26.7-8.4,8.4-21.5,12.4-39.3,12.4Zm8.5-48.4c-9.1,0-15.1,3.1-18.8,7.6-3,3.4-4.6,7.7-4.6,12.2,0,7.2,5,12,17.2,12,9.2,0,15.1-3.1,18.9-7.6,2.9-3.4,4.6-7.8,4.6-12.2-.1-7.2-5.1-12-17.3-12Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m125.7,0l-37,210c-.2,1-1.1,1.8-2.1,1.8H2.2c-1.2,0-2.2-1-2.2-2.2v-.4l17.2-97.8c2.6-14.4,10.8-28.3,22.9-38.6L125.7,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "153.1 0 137.4 88.8 110.1 88.8 125.8 0 153.1 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "180.4 0 164.7 88.8 144.2 88.8 159.9 0 180.4 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "200.9 0 185.2 88.8 171.6 88.8 187.2 0 200.9 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m214.3,1.7l-15.1,86c-.1.7-.7,1.2-1.4,1.2h-5.6L207.9.1h5.1c.8,0,1.5.7,1.4,1.5q-.1,0-.1.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurismo);
export default __webpack_public_path__ + "static/media/Turismo.b9b7de9e375165bd1e79026bfea4ee4b.svg";
export { ForwardRef as ReactComponent };